export const modes = {
  calendar: 'calendar',
  agenda: 'agenda',
};
